import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Paginated from "./Paginated";
import { COLUMNS } from "./orderColumn"
import { getDate } from "../../../utils/helper";
import { getDynamicdata } from "../campaigns/services";

const Orders = () => {
    const [loader, setLoader] = useState(false);
    const [order, setOrder] = useState([])
    const [data, setData] = useState([]);
    const [openRow, setOpenRow] = useState(null);

    useEffect(() => {
        const fetch = async () => {
            setLoader(true);
            let tempToken = JSON.parse(localStorage.getItem("token_gen"));
            tempToken = tempToken?.access_token;
            const id = localStorage.getItem("Id");
            const res = await getDynamicdata(tempToken, id);
            if (res.message === "Success") {
                setOrder(res?.data)
            }
            setLoader(false)
        };
        fetch();
    }, []);

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "approved":
                return "text-success";
            case "rejected":
                return "text-danger";
            default:
                return "text-warning";
        }
    };

    useEffect(() => {
        if (order?.length > 0) {
            const tempData = order.map((ele, index) => {
                if (order?.length > 0) {
                    return {
                        ...ele,
                        callEndTime: getDate(ele?.requestData?.callEndTime, "DD-MM-YYYY hh:mm:ss"),
                        distributor: ele?.requestData?.distributorErpId,
                        order_status: <span className={getStatusColor(ele?.requestData?.order_status)}>
                            {ele?.requestData?.order_status ? ele?.requestData?.order_status : "Pending"}
                        </span>,
                        salesassociate: (
                            <>
                                {ele?.requestData?.employeeName}<br />
                                {ele?.requestData?.employeePhoneNumber}
                            </>
                        ),
                        orderdetails: (
                            <div style={{ minWidth: "350px", display: "block" }}>
                                <div className="d-flex flex-column align-items-start">
                                    <div className="text-break">
                                        <span className="fw-bold">Beat name: </span>{ele?.requestData?.beatName}
                                    </div>

                                    <div className="text-break">
                                        <span className="fw-bold">Beat Id: </span>{ele?.requestData?.beatERPId}
                                    </div>

                                    <div className="text-break">
                                        <span className="fw-bold">Wholesaler name: </span>{ele?.requestData?.outlet?.ownersName}
                                    </div>

                                    <div className="text-break">
                                        <span className="fw-bold">Contact no: </span>{ele?.requestData?.outlet?.ownersNo}
                                    </div>

                                    <div className="text-break">
                                        <span className="fw-bold">Value: </span>{ele?.requestData?.netValue}
                                    </div>

                                    <div className="text-break">
                                        <span className="fw-bold">Order units: </span>{ele?.requestData?.orderInUnits}
                                    </div>
                                    <div className="text-break">
                                        <span className="fw-bold">Address: </span>
                                        {ele?.requestData?.outlet?.address}, {ele?.requestData?.outlet?.city}, {ele?.requestData?.outlet?.state}, {ele?.requestData?.outlet?.pinCode}
                                    </div>
                                </div>

                                <div className="product_box">
                                    <div className="product_box_header">
                                        <h3 onClick={() => setOpenRow((prev) => (prev !== index ? index : null))} className={openRow === index ? "active" : ""}>Product Details</h3>
                                    </div>
                                    {<div className={`product_box_body  ${openRow === index ? "active" : ""}`}>
                                        <table table
                                            className="table table-bordered table-striped"
                                            style={{ fontSize: "12px", marginBottom: 0 }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th style={{ padding: "4px" }}>Product Name</th>
                                                    <th style={{ padding: "4px" }}>Quantity</th>
                                                    <th style={{ padding: "4px" }}>Price</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {ele?.requestData?.sales?.map((prod, i) => (
                                                    <tr key={i}>
                                                        <td style={{ padding: "4px" }}>{prod?.productName}</td>
                                                        <td style={{ padding: "4px" }}>{prod?.quantity}</td>
                                                        <td style={{ padding: "4px" }}>{prod?.price}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>}

                                </div>
                            </div >
                        )
                    };
                }
                return ele;
            });
            setData(tempData?.length ? tempData.reverse() : []);
        }
    }, [order, openRow]);

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Header name={"Orders Approval"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Orders Details</h4>
                            </div>
                        </div>
                        <div className="dashboard__body">
                            <Paginated data={data || []} columns={COLUMNS} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



export default Orders